import React from 'react';
import Card from '@material-ui/core/Card';
import ServiceBars from '../components/ServiceBars';
import '../css/ResearchPage.css';
// import sample from '../images/network.mp4';

/**
 * This function renders the Research page
 * @component ResearchPage
 * @return {Component} ResearchPage component
 */
export default function ResearchPage() {
  return (
    <div>
      <Card
        style={{
          padding: '50px',
          width: '1200px',
          margin: '30px auto 30px auto',
        }}
      >
        <div style={{borderBottom: '1px solid silver', paddingBottom: '5px'}}>
          <h1 style={{paddingBottom: '2px'}}>
            Physics Infrastructure Research & Development at A.I.S.
          </h1>
        </div>
        <br />
        <p>
          Theoretical and practical physics research initiatives at the Advanced
          Intelligence Services Corporation are selected for development based
          on historic and recent discoveries in the definition and conduct
          analysis of metabolic, biological, and artificial physics
          infrastructure, made during scientific investigations produced through
          U.S. Government funding and, beyond realized and projected costs, by
          contextual environmental conditions, as well as the limits of
          information technologies utilized before, during, and after research
          began, such as personal journals, on-line forums, and metabolic
          physics headsets, utilized to determine certain details about specific
          physics functions for the purpose of engineering and managing a
          secure, long-term platform from which to simultaneously serve critical
          biodata and digital era media throughout the life and course of our
          organization’s intended multi-circa legacy.
        </p>
        <div style={{height: '5px'}} />
        <h2>Meta Tech Beyond 2022</h2>
        <p>
          {' '}
          With respect to the highest level of technology achievable within our
          lifetimes, A.I.S. plans to become a participating physics research
          organization sharing field information with other industry and
          military experts by the use of metabolic physics computer-assisted
          relay (expected 2025), and intends to engineer, manufacture and
          utilize wireless multi-circa meta relay information management
          technologies by 2032 to be used for the purpose of transmitting
          critical biodefense data to credentialed personnel.
        </p>
        <div style={{height: '5px'}} />
        <h2>Space Exploration & Living</h2>
        <p>
          The upgrade of virtual and true-time space exploration technologies
          represents the next generation of metabolic, biological, and
          artificial physics infrastructure research for the Advanced
          Intelligence Services Corporation. Orbital laboratories, off-planet
          robotic manufacturing techniques, life support systems, and
          intra-geospatial engineering (VR exploration) hardware development
          programs are just a few of the research initiatives A.I.S. will
          maintain over the next twenty years.
        </p>
        <div style={{height: '5px'}} />

        <h2>National Biodefense</h2>
        <p>
          In 2022, national security is measured by the confidence of a
          dependable, and precise understanding of the growing global exchange
          occurring around us. Field observations give us a clear sense of
          critical core asset risk symptoms, however, international discoveries
          in biotechnology have taken the U.S. Military’s needs above and beyond
          the analyses and projections of previous generations. Together, we can
          win the war against metabolic physics warfare and maximize prosperous
          relations with nation-states of equal capability.
        </p>
        <div style={{height: '5px'}} />

        {/* QUOTE */}

        <p style={{fontStyle: 'italic', fontSize: '22px', color: '#505050'}}>
          "It is essential to safely and responsibly research the Universe
          around us. Education of the biosciences demonstrates more reality
          about our choices, confirms our devotion to patriotism, and shapes a
          rational plan for participation in more challenging endeavors. As a
          frontrunning biotechnologist, I will continue to learn and maximize my
          contributions to society and culture through Government and God.” –
          Jim D. Ray, Founder & C.E.O., Advanced Intelligence Services
          Corporation. <a href="/ceo">Learn More</a>
        </p>

        {/* ----- */}

        <div style={{height: '5px'}} />

        <h2>Results</h2>
        <p>
          The use of classic and proprietary standardized scientific research
          metrics to document domestic field and dry lab experimentation
          observations are evidence of our organization’s long-term
          participation in the development and delivery of ethical research
          practices, superior technological innovations, and respected
          information products that benefit the American military for a
          lifetime.
        </p>
        <p>
          To order a research subscription or request a custom information
          product, contact the Advanced Intelligence Services Corporation at:
          1-800-427-9479, or e-mail: services@aisincorporated.com.
        </p>
        <div style={{height: '5px'}} />
      </Card>
      <ServiceBars />
    </div>
  );
}
